import React from 'react';
import SectionReservationSummary from './section_reservation_summary';

const SectionPlace = ({ event, setEvent, setEventDateError, placeError, clearSelectedPlace, reservationSummary, onEditReservation, onCancelReservation }) => {

  const onEventDateError = React.useCallback(() => {
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
    } else {
      setEventDateError('');
    }
  }, [event]);

  return (
    <section id="place">
      <>
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-1 mt-3 d-inline-block">
          場所
          <span className="text-fz-14px text-fw-bold text-orange mb-1 mt-1 ml-2 d-inline-block">
            必須
          </span>
        </p>
      </div>
      {reservationSummary && (
        <SectionReservationSummary
          summary={reservationSummary}
          onEdit={onEditReservation}
          onCancel={onCancelReservation}
        />
      )}
      </>
      <div
        className={`shadow-sm mb-0 ${
          !!placeError ? 'bg-light-pink' : 'bg-white'
        }`}
      >
        <div className="container col-md-8 col-lg-6 p-3_5">
          {placeError && (
            <p className="text-danger text-fz-small mb-0">{placeError}</p>
          )}
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">開催場所</p>
            <input
              id="place"
              value={event.place || ''}
              onChange={(e) => {
                setEvent((prev) => ({ ...prev, place: e.target.value }))
                if (e.target.value === '') {
                  clearSelectedPlace()
                }
              }
              }
              onClick={() => onEventDateError()}
              className="col-8 p-0 textarea--eventreport text-right"
              placeholder="新宿駅西口"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionPlace;
